import { gql } from '@apollo/client';

export const APP_META_GROUPS_QUERY = gql`
  query AppMetaGroups($first: Int, $after: String) {
    appMetaGroups(first: $first, after: $after) {
      page {
        edges {
          node {
            _id
            title
            description
            icon
            appTypes
            order
            isShowWelcome
            orderWelcome
            isFree
            isSkipSelectApp
            settings
            appContent
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
